/**
 * Contratos zod del endpoint Productos.
 */

import { z } from 'zod';

export const ProductoSchema = z.object({
  gtin: z.string().regex(/^\d{14}$/, 'GTIN debe ser 14 dígitos'),
  nombre: z.string().min(1),
  presentacion: z.string().min(1),
});

export const GetProductosResponse = z.array(ProductoSchema);

export type Producto = z.infer<typeof ProductoSchema>;
